import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  TextField,
  Grid,
  Container,
  Autocomplete,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import ShepButton from "@/components/GenericComponents/ShepButton";
import { useDispatch } from "react-redux";
import { handleAddCatalog } from "@/features/connections/manageCatalogDataSlice";
import { defaultCode } from "@/features/connections/integrationSlice";
import axios from "@/features/axiosHelper";
//SHEP-940 Duplicate of AddTaxGroupPopup with a couple tweaks
//required since the original required being used within a grid
//removed redux states and grid context

const EmailAddTaxGroupPopup = ({
  open,
  onClose,
  onSuccess,
  initialCode = "",
  connectionId,
  connectionName = "",
  artifactType = 2011,
}) => {
  const dispatch = useDispatch();
  const [dataValues, setDataValues] = useState({});

  useEffect(() => {
    if (open) {
      setDataValues({
        TaxGroupCode: initialCode,
      });
    }
  }, [open, initialCode]);

  const validateForm = () => {
    if (dataValues.TaxGroupCode === defaultCode) {
      return {
        isValid: false,
        message: `Tax Group code cannot be saved as ${defaultCode}`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
    setDataValues({});
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setDataValues((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchCatalog = async () => {
    try {
      const response = await axios.get("/email/catalogs", {
        params: {
          connectionId: connectionId,
          dataType: artifactType,
          maxCount: 1,
          search: dataValues.TaxGroupCode,
          parentCatalogId: null,
        },
      });
      const results = response.data.Records;
      return results.length > 0 ? response.data.Records[0] : null;
    } catch (error) {
      console.error("Error fetching new catalog: ", error);
      return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={"xl"}
      fullWidth={true}
      PaperProps={{ style: { borderRadius: 15 } }}
    >
      <DialogTitle
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          fontSize: "24px",
          borderRadius: "15px 15px 0 0",
          padding: "16px 24px",
        }}
      >
        <div style={{ fontWeight: "var(--font-semi-bold)" }}>
          {"Add Catalog - Tax Group for " + (connectionName || "Connection")}
        </div>
        <IconButton
          onClick={handleClose}
          className="closeIconButton"
          style={{ color: "var(--default-light)" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="dialogContent"
        style={{
          backgroundColor: "var(--disabled)",
          padding: "35px",
          minWidth: 400,
        }}
      >
        <Container>
          <Grid
            container
            spacing={2}
            rowSpacing={1}
            style={{ marginBottom: "20px", marginTop: "20px" }}
            sx={{
              px: 20,
            }}
          >
            <Grid item xs={4} />
            <Grid item xs={4}>
              <Typography>Tax Group Code </Typography>
              <TextField
                variant="outlined"
                name="TaxGroupCode"
                value={dataValues?.TaxGroupCode || ""}
                onChange={handleChange}
                sx={{
                  width: 250,
                  marginTop: 1,
                  marginBottom: 2,
                }}
              />
            </Grid>
            <Grid item xs={4} />
          </Grid>
        </Container>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <ShepButton variant="secondary" onClick={handleClose}>
          Cancel
        </ShepButton>
        <ShepButton
          onClick={async () => {
            const onSuccessfulSave = async () => {
              handleClose();
              if (onSuccess) {
                const newData = await fetchCatalog();
                onSuccess(newData);
              }
            };
            await handleAddCatalog(
              validateForm,
              onSuccessfulSave,
              dispatch,
              connectionId,
              artifactType,
              JSON.stringify({
                ...dataValues,
                connectionName,
              }),
            );
          }}
        >
          Add
        </ShepButton>
      </DialogActions>
    </Dialog>
  );
};

export default EmailAddTaxGroupPopup;
